import { render, staticRenderFns } from "./banner-wheel.vue?vue&type=template&id=185268e8&"
import script from "./banner-wheel.vue?vue&type=script&lang=js&"
export * from "./banner-wheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports